(() => {
  const initializedSections = new WeakSet()

  const initProductCare = (section) => {
    if (!section || initializedSections.has(section)) return

    initializedSections.add(section)
    section.classList.add('is-ready')

    const revealItems = Array.from(
      section.querySelectorAll('[data-mc-product-care-reveal], [data-mc-product-care-item]')
    )

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      revealItems.forEach((item) => item.classList.add('is-visible'))
      return
    }

    window.requestAnimationFrame(() => {
      revealItems.forEach((item, index) => {
        window.setTimeout(() => {
          item.classList.add('is-visible')
        }, 80 + index * 120)
      })
    })
  }

  const initAllProductCareSections = (root = document) => {
    root.querySelectorAll('[data-mc-product-care]').forEach(initProductCare)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllProductCareSections())
  } else {
    initAllProductCareSections()
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAllProductCareSections(event.target)
  })
})()
